import request from '@/utils/request'

//实习考勤签到
export function addpracticeattendance(data) {
    return request({
        url: '/portal/practice-attendance/add',
        method: 'post',
        data
    })
}

//获取学生实习考勤列表
export function getpracticeattendancestudentlist(params) {
    return request({
        url: '/portal/practice-attendance/get-student-list',
        method: 'GET',
        params
    })
}

//获取实习考勤列表
export function getpracticeattendancelist(params) {
    return request({
        url: '/portal/practice-attendance/get-list',
        method: 'GET',
        params
    })
}

//获取实习考勤汇总数据
export function getpracticeattendanceinfo(params) {
    return request({
        url: '/portal/practice-attendance/get-info',
        method: 'GET',
        params
    })
}

//修改考勤状态
export function attendEdit(data) {
    return request({
        url: '/portal/practice-attendance/edit-status',
        method: 'post',
        data
    })
}

//获取实习负责老师列表
export function choosePlanTea(params) {
    return request({
        url: '/portal/practice-plan-teacher/get-plan-teacher-list',
        method: 'GET',
        params
    })
}

//新增学生和学生绑定关系的新增
export function addPlanTea(data) {
    return request({
        url: '/portal/practice-plan-student/teacher-add',
        method: 'post',
        data
    })
}